import { render, staticRenderFns } from "./public-header-layout.vue?vue&type=template&id=29475c2b"
import script from "./public-header-layout.vue?vue&type=script&lang=js"
export * from "./public-header-layout.vue?vue&type=script&lang=js"
import style0 from "./public-header-layout.vue?vue&type=style&index=0&id=29475c2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports